module.exports = __webpack_public_path__ + "static/media/ASA_Article.7f231fe6.jpg";